export default {
    headers: {
        notifications: {
            id: 'notifications.headers.notifications'
        },
        notificationsSettings: {
            id: 'notifications.headers.notificationsSettings'
        },
        notificationsHistory: {
            id: 'notifications.headers.notificationsHistory'
        },
        notifyMeWhen: {
            id: 'notifications.headers.notifyMeWhen'
        }
    },
    buttons: {
        back: {
            id: 'notifications.buttons.back'
        },
        viewAllNotifications: {
            id: 'notifications.buttons.viewAllNotifications'
        },
        openNotificationsHistory: {
            id: 'notifications.buttons.openNotificationsHistory'
        },
        saveChanges: {
            id: 'notifications.buttons.saveChanges'
        },
        loadMore: {
            id: 'notifications.buttons.loadMore'
        },
        dismissAll: {
            id: 'notifications.buttons.dismissAll'
        },
        filter: {
            id: 'notifications.buttons.filter'
        },
        apply: {
            id: 'notifications.buttons.apply'
        },
        clearAll: {
            id: 'notifications.buttons.clearAll'
        },
        clear: {
            id: 'notifications.buttons.clear'
        },
        confirm: {
            id: 'notifications.buttons.confirm'
        },
        cancel: {
            id: 'notifications.buttons.cancel'
        }
    },
    infos: {
        noNotifications: {
            id: 'notifications.infos.noNotifications'
        }
    },
    labels: {
        notificationType: {
            id: 'notifications.labels.notificationType'
        },
        allNotificationTypes: {
            id: 'notifications.labels.allNotificationTypes'
        },
        dateRangePicker: {
            id: 'notifications.labels.dateRangePicker'
        },
        type: {
            id: 'notifications.labels.type'
        },
        status: {
            id: 'notifications.labels.status'
        }
    },
    listTimelines: {
        today: {
            id: 'notifications.listTimelines.today'
        },
        yesterday: {
            id: 'notifications.listTimelines.yesterday'
        },
        thisWeek: {
            id: 'notifications.listTimelines.thisWeek'
        },
        older: {
            id: 'notifications.listTimelines.older'
        }
    },
    status: {
        active: {
            id: 'notifications.status.active'
        },
        read: {
            id: 'notifications.status.read'
        },
        dismissed: {
            id: 'notifications.status.dismissed'
        }
    },
    partials: {
        goToPatientProfile: {
            id: 'notifications.partials.goToPatientProfile'
        },
        leadingClick: {
            id: 'notifications.partials.leadingClick'
        },
        visitsHistory: {
            id: 'notifications.partials.visitsHistory'
        }
    },
    alerts: {
        confirmDismissFilteredNotifications: {
            id: 'notifications.alerts.confirmDismissFilteredNotifications'
        }
    }
};
